/* eslint-disable import/first */
import '@atlaskit/css-reset'; // eslint-disable-line

// Polyfills
import './polyfills';

// React
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// App
import './fonts/fonts.css';
import './reset.css';
import './intercom';
import App from './App';
import store from './store';
import migration from './migration';
import sentry from './sentry';

sentry();

const root = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  root,
);

migration();
